export default __webpack_public_path__ + "static/media/doggo-dark.a0fd7342.png";